import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  successResponse: {},
  isLoading: false,
  isError: false,
  error: false
};
const baggageDamageClaimSlice = createSlice({
  name: "baggageDamageClaim",
  initialState,
  reducers: {
    baggageDamageClaimRequest: (state, action) => {
      state.isLoading = true;
      state.error = false;
      state.isError = false;
    },
    baggageDamageClaimSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.successResponse = action.payload;
    },
    baggageDamageClaimFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.isError = true;
    },
    resetBaggageDamageClaim: state => {
      state.successResponse = {};
      state.isLoading = false;
      state.isError = true;
      state.error = false;
    }
  }
});
export const {
  baggageDamageClaimRequest,
  baggageDamageClaimSuccess,
  baggageDamageClaimFailure,
  resetBaggageDamageClaim
} = baggageDamageClaimSlice.actions;
export default baggageDamageClaimSlice.reducer;